// extracted by mini-css-extract-plugin
export default {"wrapper":"SimpleDropdown_wrapper__vwAJS","placeholderTextColor":"SimpleDropdown_placeholderTextColor__k5Z4g"};